module.exports = __webpack_public_path__ + "images/thumbs-up-fill3075ccbc3114c13a0dc2a7ef806d91d8.svg";